import React from "react";
import { motion } from "framer-motion";
import "../styles/Portfolio.css";
import Banner1 from "../assets/Banner1.jpg";
import Banner3 from "../assets/Banner3.jpg";
import French from "../assets/french.jpg";
// import Project1 from "../assets/project1.jpg";
// import Project2 from "../assets/project2.jpg";
// import Project3 from "../assets/project3.jpg";
// import Project4 from "../assets/project4.jpg";
// import Project5 from "../assets/project5.jpg";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.3, duration: 0.6 },
  }),
};

// const projects = [
//   { id: 1, title: "Residential (Franklin Cove Apartment)", image: Project4 },
//   { id: 2, title: "Commercial Complex", image: Project5 },
//   { id: 3, title: "Entertainment Arena", image: Project3 },
//   { id: 4, title: "Government Infrastructure", image: Project2 },
//   { id: 5, title: "School Buildings", image: Project1 },
// ];

const Portfolio = () => {
  return (
    <section className="portfolio-page">
      {/* Header Section */}
      <motion.header
        className="portfolio-hero"
        initial="hidden"
        animate="visible"
        variants={fadeUp}
      >
        <h1>Our Projects</h1>
        <p className="portfolio-subheading">
          The Gold Standard in Luxury Living and Modern Infrastructure
        </p>
      </motion.header>

      {/* Intro Section 1 */}
      <div className="portfolio-intro">
        <motion.div
          className="portfolio-intro-image"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
        >
          <img src={Banner1} alt="Kingdom Homes" height={700} />
        </motion.div>

        <motion.div
          className="portfolio-intro-text"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          custom={1}
        >
          <h2>Kingdom Homes</h2>
          <p>
            <strong>
              Where Craftsmanship Defines Luxury, and Every Home Tells a Story.
            </strong>
            <br />
            <br />
            Kingdom Homes stands as a landmark creation by TMC Construction,
            envisioned to bring together luxury, innovation, and sustainability
            in perfect harmony. Designed for modern families who seek elegance
            without compromise, Kingdom Homes redefines what it means to live in
            comfort and class.
            <br />
            <br />
            Every inch of this project reflects an obsession with detail — from
            its contemporary architectural language to the use of premium
            materials that ensure both beauty and durability. Expansive living
            spaces, natural lighting, and thoughtful design combine to create
            homes that are not only stunning to look at but a joy to live in.
            <br />
            <br />
            Beyond aesthetics, Kingdom Homes is built on principles of
            sustainability. Eco-friendly construction methods, energy-efficient
            layouts, and smart home provisions make it as responsible as it is
            luxurious. With landscaped surroundings, serene ambiance, and secure
            community living, Kingdom Homes is more than just a residence — it’s
            a refined lifestyle experience.
            <br />
            <br />
            Whether it’s the modern interiors, the meticulous craftsmanship, or
            the seamless blend of technology and comfort — every detail is
            designed to elevate the way you live. Kingdom Homes is not merely
            about owning a house; it’s about embracing a space that mirrors your
            success, taste, and vision for the future.
            <br />
            <br />
            <strong>
              Kingdom Homes — Where Luxury Lives, and Legacy Begins.
            </strong>
          </p>
        </motion.div>
      </div>

      {/* Intro Section 2 */}
      <div className="portfolio-intro reverse">
        <motion.div
          className="portfolio-intro-image"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          custom={1}
        >
          <img src={French} alt="French Apartments" height={800} />
        </motion.div>
        <motion.div
          className="portfolio-intro-text"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
        >
          <h2>French Apartments</h2>
          <p>
            <strong>Inspired by Paris. Built for the Modern Indian Lifestyle.</strong>
            <br />
            <br />
            French Apartments is a signature residential development that fuses
            the timeless elegance of European design with the practicality and
            vibrance of modern Indian living. Conceived as a tribute to
            architectural artistry, this project reflects TMC Construction’s
            unwavering commitment to quality, innovation, and sustainability.
            <br />
            <br />
            The façade of French Apartments showcases graceful lines,
            symmetrical layouts, and soft textures inspired by French
            architectural traditions, while the interiors are designed for
            functionality and comfort. Each apartment is a masterpiece of design
            — featuring spacious rooms, high ceilings, and large windows that
            invite natural light to create an airy, peaceful atmosphere.
            <br />
            <br />
            Attention to detail defines every corner, from the refined flooring
            and elegant fixtures to the perfectly balanced color palette that
            enhances both beauty and mood. Residents enjoy modern amenities
            including landscaped gardens, recreation zones, fitness spaces, and
            secure parking — all within a self-contained, community-driven
            environment.
            <br />
            <br />
            Sustainability lies at the heart of French Apartments, with
            eco-conscious construction materials, efficient water and waste
            management systems, and energy-saving design strategies ensuring
            that every home is built for a greener tomorrow.
            <br /><br />
            The project doesn’t just provide a place to live — it offers a
            lifestyle that blends European sophistication with Indian warmth,
            creating a space that resonates with grace, balance, and purpose.
            <br /><br />
            <strong>French Apartments — A Living Experience Where Elegance, Comfort, and
            Heritage Unite.</strong>
          </p>
        </motion.div>
      </div>

      {/* Project Grid Section */}
      {/* <motion.div
        className="portfolio-grid"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
      >
        {projects.map((project, i) => (
          <motion.div
            key={project.id}
            className="portfolio-item"
            variants={fadeUp}
            custom={i * 0.2}
          >
            <img
              src={project.image}
              alt={project.title}
              className="portfolio-image"
            />
            <p className="portfolio-title">{project.title}</p>
          </motion.div>
        ))}
      </motion.div> */}

      {/* Outro Section */}
      <motion.div
        className="portfolio-footer"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
      >
        <h3>We Build Landmarks That Inspire Generations</h3>
        <p>
          From residential to commercial, every project we undertake stands as a
          testament to our commitment to quality, design, and excellence.
        </p>
      </motion.div>
    </section>
  );
};

export default Portfolio;
